import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight, Clock, MapPin } from "lucide-react";
import { DESTINATIONS } from "@/data/content";

export default function Destinations({ onExplore }) {
  return (
    <section id="destinations" className="py-24 md:py-32 px-6 lg:px-10" data-testid="destinations-section">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <span className="w-10 h-px bg-[#C9A227]" />
              <span className="overline">Popular Destinations</span>
            </div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-[#0A2342] max-w-2xl">
              Where would you like to wake up tomorrow?
            </h2>
          </div>
          <p className="text-[#6B7280] max-w-md leading-relaxed">
            Ten signature destinations — each curated with concierge-grade hotels, private experiences and seamless transfers.
          </p>
        </div>

        {/* Bento grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-5">
          {DESTINATIONS.map((d, i) => {
            // create varied tile sizes for bento feel
            const big = i === 0 || i === 5;
            return (
              <motion.a
                key={d.slug}
                href="#packages"
                onClick={onExplore}
                data-testid={`destination-card-${d.slug}`}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: (i % 4) * 0.07 }}
                className={`group relative overflow-hidden rounded-3xl cursor-pointer ${
                  big ? "row-span-2 col-span-2 aspect-square md:aspect-auto" : "aspect-[4/5]"
                }`}
              >
                <img
                  src={d.image}
                  alt={d.name}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1.4s] ease-out group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-transparent" />

                <div className="absolute top-4 right-4 w-10 h-10 rounded-full glass flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                  <ArrowUpRight className="w-4 h-4 text-[#0A2342]" />
                </div>

                <div className="absolute inset-x-0 bottom-0 p-5 md:p-6 text-white">
                  <div className="flex items-center gap-1.5 text-[#C9A227] text-xs uppercase tracking-[0.2em] mb-2">
                    <MapPin className="w-3 h-3" />
                    {d.tagline}
                  </div>
                  <h3 className="font-display text-2xl md:text-3xl">{d.name}</h3>
                  <div className="mt-3 flex items-center justify-between text-xs md:text-sm">
                    <span className="opacity-90">
                      from <span className="font-semibold text-white">{d.price}</span>
                    </span>
                    <span className="inline-flex items-center gap-1 opacity-80">
                      <Clock className="w-3 h-3" /> {d.duration}
                    </span>
                  </div>
                </div>
              </motion.a>
            );
          })}
        </div>
      </div>
    </section>
  );
}
